import React from 'react';
import { Radio as MuiRadio } from '@mui/material';
import './Radio.scss';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioProps {
  label: string;
  options: RadioOption[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  name?: string;
  id?: string;
}

export const Radio: React.FC<RadioProps> = ({
  label,
  options,
  value,
  onChange,
  onBlur,
  error,
  name,
  id,
}) => {
  return (
    <div className="radio-field">
      <label className="radio-label">{label}</label>
      <div className="radio-options">
        {options.map((option) => (
          <div key={option.value} className="radio-option">
            <MuiRadio
              id={`${id || name}-${option.value}`}
              name={name || label}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              onBlur={onBlur}
              size="small"
            />
            <label htmlFor={`${id || name}-${option.value}`}>{option.label}</label>
          </div>
        ))}
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};
